import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Title from 'components/Title';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(({ spacing, breakpoints }) => ({
    root: {
        // maxWidth: '100%',
        // padding: spacing(0, 4),
        // margin: 'auto',
        // overflow: 'hidden',
        background: 'transparent',
        [breakpoints.down('md')]: {
            padding: spacing(2),
        },
    },
    paper: {
        background: 'transparent',
        padding: spacing(0, 3),
    },
    loading: {
        height: '100%',
    },
}));

function Base(props) {
    const {
        actions, disableTitle, children, rootStyle, rootClass, title: overrideTitle,
    } = props;
    const classes = useStyles();
    const { title } = useSelector((state) => state.app);

    return (
        <div className={clsx(classes.root, rootClass)} style={rootStyle}>
            {!disableTitle && <Title title={overrideTitle || title} actions={actions} />}
            <Box p={3}>
                {children}
            </Box>
        </div>
    );
}

Base.displayName = 'Base';
Base.propTypes = {
    actions: PropTypes.array,
    title: PropTypes.string,
    disableTitle: PropTypes.bool,
    rootClass: PropTypes.string,
};
Base.defaultProps = {
    actions: [],
    disableTitle: false,
    rootClass: '',
    title: '',
};

export default Base;
